/*
 * 学校向け LP の CTA 遷移先。
 * TODO: 学校専用の相談窓口（LINE / 専用フォーム）が用意され次第、CONSULT を差し替える。
 *       現状はサロン向け LP と同じ問い合わせフォームに送っている。
 */
export const DOC_DOWNLOAD_URL = 'https://memorii-works.com/contact';
export const CONSULT_URL = 'https://memorii-works.com/contact';
export const SCHOOL_LOGIN_URL = '/school/service';
export const STUDENT_APP_URL =
  'https://apps.apple.com/jp/app/memorii-works/id1578278781';
export const STUDENT_WEB_URL = 'https://memorii-works.com/';
